export const APP_HOME_ROUTE = '';
export const APP_CATALOG_ROUTE = 'catalog';
export const APP_PRODUCT_ROUTE = 'product';
export const APP_SELLER_ROUTE = 'seller';
export const APP_SUPPORT_ROUTE = 'kundenservice';
export const APP_LEGAL_PAGES_ROUTE = 'legal';
export const APP_LEGAL_PAGE_ABOUT = 'about';
export const APP_LEGAL_PAGE_TERMS_AND_CONDITIONS = 'terms-of-use-and-purchase';
export const APP_LEGAL_PAGE_IMPRINT = 'imprint';
export const APP_LEGAL_PAGE_PRIVACY_POLICY = 'privacy-policy';
export const APP_LEGAL_PAGE_CANCELLATION_POLICY = 'cancellation-policy';
export const APP_LEGAL_PAGE_DISPOSAL_AND_ENV = 'disposal-and-environmental-regulations';
export const APP_USER_LOGIN_ROUTE = 'auth/login';
export const APP_USER_REGISTER_ROUTE = 'auth/registration';
export const APP_USER_IDAM_REGISTER_ROUTE = 'auth/register';
export const APP_USER_VALIDATE_EMAIL_ROUTE = 'auth/validate-email';
export const APP_USER_SECURE_LOGIN_NOTICE_ROUTE = 'auth/secure-login-notice';
export const APP_USER_LOGIN_FLOW_TYPE_ROUTE = 'auth/login-flow-type';
export const APP_USER_IDAM_ADD_BUSINESS_PROFILE_ROUTE = 'auth/registration/add-business-details';
export const APP_USER_PASSWORDLESS_ADD_BUSINESS_DETAILS_ROUTE = 'auth/registration/passwordless-business-details';
export const APP_USER_VAT_ID_CHECK_ROUTE = 'auth/registration/check-vat';
export const APP_USER_TAX_ID_CHECK_ROUTE = 'auth/registration/check-tax-id';
export const APP_USER_BRANCHES_SELECTION_ROUTE = 'auth/registration/branch-selection';
export const APP_CHECKOUT_ROUTE = 'checkout';
export const APP_BRAND_PLP_ROUTE = 'b';
export const APP_CUSTOM_PLP_ROUTE = 'landing';
export const APP_CATEGORY_ROUTE = 'c';
export const APP_SEARCH_ROUTE = 'search';
export const APP_CUSTOM_HUB_ROUTE = 'hub';
export const APP_LANDING_PAGE_ROUTE = 'content';
export const APP_ALL_OFFERS_ROUTE = 'all-offers';
export const APP_PROMO_ROUTE = 'promo';
export const APP_USER_PASSWORDLESS_SIGNUP_ROUTE = 'auth/passwordless-signup';
export const APP_CART_ROUTE = 'cart';
export const CHECKOUT_ROUTE = 'checkout';
export const CHECKOUT_CART_ROUTE = `${CHECKOUT_ROUTE}/${APP_CART_ROUTE}`;
export const ASSISTED_SALES_LOGIN_REDIRECT_ROUTE = 'b/metro-professional';

export const ORDER_ROUTE = 'order';
export const ORDER_STEP_ADDRESS = 'address';
export const ORDER_STEP_PAYMENT = 'payment';
export const ORDER_STEP_REVIEW = 'review';
export const ORDER_STEP_THANKYOU = 'thank-you';


export const CHECKOUT_STEPS_ROUTE = `${APP_CHECKOUT_ROUTE}/${APP_CHECKOUT_ROUTE}/${ORDER_ROUTE}`;
export const APP_ADDRESSES_ROUTE = 'addresses';
export const APP_BILLING_ROUTE = 'billing';
export const APP_SHIPPING_ROUTE = 'shipping';

export const APP_USER_ACCOUNT_ROUTE = 'user-account';
export const APP_AUTH_ROUTE = 'auth';
export const LOGIN_ROUTE = 'login';
export const REGISTRATION_ROUTE = 'registration';
export const APP_ENTREPRENEUR_ACCOUNT_ROUTE = 'account';
export const USER_ADD_BUSINESS_ROUTE = 'registration-type';
export const USER_ADD_PRIVATE_OR_BUSINESS_ROUTE = 'registration-type-private-or-business';
export const CUSTOMER_WORKPLACE_ROUTE = 'workplace';
export const IMPERSONATE_ROUTE = 'impersonate';
export const BUY_AGAIN_ROUTE = 'account/buy-again';
export const NEWSLETTER_LANDING = 'newsletter-confirmation';
export const NOT_FOUND_PAGE = 'not-found';
export const SERVER_ERROR_PAGE = 'server-error';
export const BLOCKED_ACCOUNT_PAGE = 'blocked-account';

export const WEEE_LANDING_PAGE = 'weee';
export const APP_BRAND_PAGE = 'brand';
export const APP_EMPLOYEE_CUSTOMERS_LIST = `${APP_AUTH_ROUTE}/customers-list`;
export const APP_SHOPPING_LIST = 'shopping-list'
export const APP_EMPLOYEE_OVERVIEW = 'assisted-sales/overview';
export const USER_PANEL_SIGN_UP = 'user-panel-sign-up'
export const CHECKOUT_PAYMENT_PAGE_URL = 'checkout/checkout/order/payment';
export const CHECKOUT_REVIEW_PAGE_URL = 'checkout/checkout/order/review';
export const CHECKOUT_THANK_YOU_PAGE_URL = 'checkout/checkout/order/thank-you';

